export const SESSION_TOKEN_HOTEL_DETAIL = 'session_token';
export const ARRIVAL_HOTEL_DETAIL = 'arrival';
export const DEPARTURE_DATE_HOTEL_DETAIL = 'departure_date';
export const ARRIVAL_DATE_HOTEL_DETAIL = 'arrival_date';

export const HOTEL_DETAIL_BASE_ROUTE = 'hotel-detail';

